import * as API from "../utility/ApiHelper"
const CATAPI_ENDPOINT = "https://catfact.ninja/fact";

export const fetchCatApiResult=()=>{
    return API.get(CATAPI_ENDPOINT);
}
